import { initGlobalEventsLogs } from '@cian/events-log';
import { init as initGlobalBehaviors } from '@cian/global-behaviors/browser';
import { init as initHttpApi } from '@cian/http-api/browser';
import { init as initTelemetry } from '@cian/telemetry/browser';
import { init as initWeb } from '@cian/web/browser';

export function initDependencies() {
  initTelemetry();
  initHttpApi();
  initWeb();
  initGlobalEventsLogs();
  initGlobalBehaviors();
}
